import { Client } from "creso-core/types";
import { INACTIVE_CLIENT_STATUSES } from "creso-core/constants";
import { EllipsisVerticalIcon, PencilIcon } from "lucide-react";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "web-design-system";
import { useNavigate } from "@tanstack/react-router";
import { ConditionalRenderer } from "@core/components/conditional-renderer";
import { getKycState } from "creso-core/utils";
import { DeleteAccount } from "./delete-account";

export function ClientContextMenu(props: {
  client?: Client;
  className?: string;
}) {
  const { client } = props;

  const navigate = useNavigate();

  if (
    !client ||
    !(
      client.status === "AUTHENTICATION_PENDING" ||
      INACTIVE_CLIENT_STATUSES.includes(client.status)
    )
  )
    return null;

  const kycState = getKycState(client);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className={props.className} variant="ghost" size="icon">
          <EllipsisVerticalIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <ConditionalRenderer condition={client.status === "SETUP_PENDING"}>
          <ConditionalRenderer condition={kycState === "complete"}>
            <DropdownMenuItem
              onSelect={() =>
                navigate({
                  to: ".",
                  search: (prev) => ({
                    ...prev,
                    modal: "onboarding",
                    client_id: client?.id,
                  }),
                })
              }
            >
              <PencilIcon />
              Finish setup
            </DropdownMenuItem>
          </ConditionalRenderer>
        </ConditionalRenderer>
        <ConditionalRenderer
          condition={
            client.status !== "SETUP_PENDING" &&
            client.status !== "AUTHENTICATION_PENDING"
          }
        >
          <DropdownMenuItem
            onSelect={() =>
              navigate({
                to: ".",
                search: (prev) => ({
                  ...prev,
                  modal: "client-lead",
                  client_id: client?.id,
                }),
              })
            }
          >
            <PencilIcon />
            Edit
          </DropdownMenuItem>
        </ConditionalRenderer>
        <DropdownMenuItem asChild>
          <DeleteAccount client={client} />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
